import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { ListRef } from 'rc-virtual-list'
import { RefObject, useEffect } from 'react'

const SCROLL_TOP_TOLERANCE = 10

/**
 * Hook to intelligently reset scroll position when new cards are added.
 * For default filter (open): Only scrolls if user is at top, otherwise preserves position.
 * For non-default filters (resolved): Always scrolls to top to show new cards.
 */
export const useResetScrollOnRequest = (
    containerRef: RefObject<ListRef>,
    isNotDefaultSuggestionCardFilter: boolean
) => {
    const {
        resetSuggestionScroll,
        setResetSuggestionScroll,
    } = useSuggestionsShallowSelector((state) => ({
        resetSuggestionScroll: state.resetSuggestionScroll,
        setResetSuggestionScroll: state.setResetSuggestionScroll,
    }))

    useEffect(() => {
        if (!resetSuggestionScroll || !containerRef.current) {
            return
        }

        // TODO: Need this when we implement the Inline changes PBI
        // if (isNotDefaultSuggestionCardFilter) {
        //     // For non-default filters (like "resolved"), always scroll to top
        //     containerRef.current.scrollTo({ index: 0, align: 'top' })
        // } else {
        // For default filter ("open"), only scroll if user is at the top
        const scrollInfo = containerRef.current.getScrollInfo()
        const isAtTop = scrollInfo.y <= SCROLL_TOP_TOLERANCE

        if (isAtTop) {
            containerRef.current.scrollTo({ index: 0, align: 'top' })
        }

        setResetSuggestionScroll(false)
    }, [
        resetSuggestionScroll,
        setResetSuggestionScroll,
        containerRef,
        isNotDefaultSuggestionCardFilter,
    ])
}
